<!--
 * @Description: 报修 维修
 * @Author: PF
 * @Date: 2023-12-13 10:34:02
 * @LastEditors: PF
 * @LastEditTime: 2023-12-13 10:36:04
-->
<template>
  <div>
    <el-dialog class="w600 h500" :model-value="openWeiXiu" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">维修</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openWeiXiu', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="维修时间" prop="wxsj">
              <el-date-picker v-model="ruleForm.wxsj" type="datetime" value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="维修结果" prop="wxjg">
              <el-input v-model="ruleForm.wxjg" type="textarea" resize="none" :autosize='{minRows: 6, maxRows: 6}' />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openWeiXiu', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import axios from 'axios'
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { actionPost, closeWindow } from '@/api/common.js'

const props = defineProps({ openWeiXiu: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openWeiXiu', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})

watch(
  () => props.openWeiXiu,
  () => {
    if (props.openWeiXiu) {
      ruleForm.value.id = props.row.id
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  actionPost({ url: '/api/v2/houqin/baoxiu/weixiu', data: ruleForm.value }).then((res) => {
    if (res.code === 200) {
      closeWindow('openWeiXiu', emits, true)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>
